module.exports = __webpack_public_path__ + "707b3ea51479f6152ed5e70da89bd49d.svg";